<script lang="ts" setup>
  import { toRefs } from 'vue'

  interface Props {
    title?: string
    noPadding?: boolean
    maximizable?: boolean
    modal?: boolean
    draggable?: boolean
  }

  const emit = defineEmits<{
    close: [_close: boolean]
  }>()
  const props = withDefaults(defineProps<Props>(), {
    noPadding: false,
    maximizable: false,
    modal: false,
    title: undefined,
    draggable: true,
  })

  const { title, noPadding } = toRefs(props)
  const isOpen = defineModel<boolean>('openState')

  function onClose(_close: boolean) {
    isOpen.value = false
    emit('close', _close)
  }
</script>
<template>
  <Dialog
    v-model:visible="isOpen"
    :header="title"
    :draggable="draggable"
    :pt="{
      root: [],
      header: ['px-2 py-0 md:px-5 md:py-2 '],
      title: ['text-base md:text-xl'],
      headeractions: {},
      content: ['px-0.5 md:px-5'],
      pcmaximizebutton: { root: ['py-0 md:py-2'] },
      pcclosebutton: { root: ['py-0 md:py-2'] }
    }"
    class="max-w-full max-h-full"
    maximizable
    modal
    @close="onClose">
    <template
      v-if="$slots.header"
      #header>
      <slot name="header" />
    </template>
    <div
      :class="[noPadding ? '' : 'md:p-4']"
      class="overflow-auto">
      <slot
        v-if="$slots.content"
        name="content" />
      <slot v-else />
    </div>
    <div
      v-if="$slots.buttons"
      class="p-4 border-t flex justify-end">
      <slot name="buttons" />
    </div>
  </Dialog>
</template>
